export enum AutomationStatus {
  INITIATE = 'initiate',
  RUNNING = 'running',
  COMPLETE = 'complete',
  ERROR = 'error',
}
